import React from 'react';
import BookingCard from './BookingCard';

interface IProps {
  bookings: any;
  bookingInfo: any;
  setBookingInfo: any;
}

const ListOfBookings = (props: IProps) => {
  const { bookings, bookingInfo, setBookingInfo } = props;
  return (
    <div className="flex flex-col gap-2.5 xl:overflow-y-auto p-2 md:pr-2.5">
      {bookings.map((info: any) => (
        <BookingCard key={info.uuid} info={info} bookingInfo={bookingInfo} setBookingInfo={setBookingInfo} />
      ))}
    </div>
  );
};

export default ListOfBookings;
